<template>
    <div>
        <div v-if="! isSubmitted">
            <div v-if="! isLoadingBlade && ! showErrorStatus">
                <h3 class="text-uppercase">Application Preview</h3>
                <em class="mb-4 text-danger">
                    Kindly check all information supplied, after submission changes can't be made...
                </em>
                <hr>

                <!-- This is profile details template here -->
                <ProfileDetails
                    :application="application" 
                    v-if="application"
                />

                <!-- This is directors details template here -->
                <DirectorDetails
                    :records="application.cpd.directors"
                    v-if="application && application.cpd && application.cpd.directors"
                />

                <!-- This is staff details template here -->
                <StaffDetails
                    :records="application.cpd.staff"
                    v-if="application && application.cpd && application.cpd.staff"
                />

                <!-- This is consultant details template here --> 
                <ConsultantDetails
                    :records="application.cpd.consultants"
                    :documentUrl="documentUrl"
                    v-if="application && application.cpd && application.cpd.consultants"
                />

                <!-- This is Documents template here --> 
                <Documents
                    :records="application.documents"
                    v-if="application && application.documents"
                />

            </div>

            <div class="col-lg-12">
                <h3 class="mb-4 text-danger">
                    Kindly check all information before submitting your application, changes can't be made after submission.
                </h3>
                <hr>
            </div>


            <div class="col-lg-12" v-if="isLoadingBlade">
                <div class="d-flex justify-content-center">
                    <img :src="loadingBladeUrl" />
                </div>
            </div>

            <div class="col-lg-12 text-center" v-if='showErrorStatus && ! isLoadingBlade'>
                <base-alert :type="errorType">
                    <!-- <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span> --> 
                    <span class="alert-inner--text">
                        <h2 class="text-white">{{errorMsg}}</h2>
                    </span>
                </base-alert>
            </div>

            <div class="col-lg-12" v-if="! isLoadingBlade"> 
                <base-button
                    type="danger"
                    @click="showPreviousPage()"
                >
                    <i class="fa fa-arrow-left"></i>
                    Previous
                </base-button>

                <base-button
                    type="success"
                    class="right"
                    @click="submitNow()"
                >
                    <i class="fa fa-save"></i>
                    {{ isloading ? 'Please Wait...' : saveButtonText }}
                </base-button>
            </div>
        </div>

        <div class="col-lg-12" v-if="isSubmitted">
            <div class="d-flex justify-content-center">
                <img :src="completeImageUrl" />
            </div>
            <br>
            <h2 class="text-uppercase text-center">
                Your application was submitted succesfully... 
            </h2>
            <h4 class="text-uppercase text-center text-danger">
                Note: You will be contacted subsequently by MDCN
            </h4>
            <hr>
            <div class="text-center">
                <router-link
                    to="/"
                    class="btn btn-lg btn-success"
                >
                    <i class="fa fa-home"></i>
                    Dashboard Now
                </router-link>
            </div>
            <br><br>
        </div>

    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import ProfileDetails from './ProfileDetails';
    import ConsultantDetails from './ConsultantDetails';
    import DirectorDetails from './DirectorDetails';
    import StaffDetails from './StaffDetails';
    import Documents from './Documents.vue';
    import swal from 'sweetalert2';// import sweet alert

    export default {
        name: 'VerificationSummary',
        props: ['displayDocuments', 'application', 'resubmit'],
        components: {
            ProfileDetails,
            ConsultantDetails,
            DirectorDetails,
            StaffDetails,
            Documents
        },
        data() {
            return {
                isLoadingBlade: false,
                isloading: false,
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isSubmitted: false
            }
        },
        computed: {
            ...mapGetters(['loadingBladeUrl', 'getRootUrl', 'completeImageUrl']),
            saveButtonText() {
                return this.resubmit ? 'Re-Send Application' : 'Submit Now';
            },
            documentUrl() {// get document url
                return this.getRootUrl+'/storage/cpd/cpd'+this.application.cpd_id;
            }
        },
        methods: {
            ...mapActions(['submitCpdApplication', 'reSubmitApplication']),
            showPreviousPage() {// go to next page
                return this.displayDocuments(true);
            },
            submitNow() {// submit application
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Proceed!'
                }).then((result) => {
                    if (result.value) {
                        if(this.resubmit) {
                            this.makeReSubmitApiCall(this.application.id);// make resubmit api call
                        } else {
                            this.makeSubmitApiCall();// make api call
                        }
                    }
                });
            },
            makeSubmitApiCall() {
                this.isloading = true;
                this.showInputErrorStatus = false;
                this.preloader();// show loading
                if(this.application.id) {// submit
                    this.submitCpdApplication(this.application.id).then((res) => {
                        this.isloading = false;
                        if(res.status) {
                            swal.fire("Application Submitted!", res.msg, "success");
                            this.isSubmitted = true;
                            // setTimeout(function() { window.location.href = '/'; }, 2000);
                        } else {
                            let msg = "An error occurred while submitting form, reload page";
                            swal.fire("Error Ocurred!", msg, "warning");
                        }
                    }).
                    catch(() => {
                        this.isloading = false;
                        let msg = "Network Failure!, kindly reload the page...";
                        swal.fire("Error Ocurred!", msg, "warning");
                    });
                }   else {
                    this.isloading = false;
                    let msg = "Network Failure!, kindly reload the page...";
                    swal.fire("Error Ocurred!", msg, "warning");
                }
            },
            makeReSubmitApiCall(id) {
                this.preloader(); // show loading
                this.reSubmitApplication(id).then((res) => {// get application record
                    if(res.status) {
                        swal.fire("Application Submitted!", res.msg, "success");
                        setTimeout(function() { window.location.href = '/applications'; }, 1000);
                    } else {
                        swal.fire("Error Occurred!", res.msg, "warning");
                    }
                }).
                catch(() => {
                    let msg = "Network Failure!, kindly reload the page...";
                    swal.fire("Network Failure!", msg, "warning");
                });
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        }
    }
</script>

<style scoped>
    .no-padding-bottom {
        padding-bottom: 0rem !important
    }
    .right {
        float: right !important;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>